import 'reflect-metadata';
import '@ant-design/v5-patch-for-react-19';
import '@~/index.css';
import '@thisisdmg/tirecloud-patterns/v2/fonts/ContinentalStagSans.css';
import '@thisisdmg/tirecloud-patterns/v2/index.css';
import App from '@/modules/core/components/app';
import Config from '@/modules/config/classes/Config';
import setupI18n from '@/modules/i18n/functions/setupI18n';
import setupSentry from '@/modules/sentry/functions/setupSentry';
import reportWebVitals from '@/reportWebVitals.ts';
import * as Sentry from '@sentry/react';
import { StrictMode, type ErrorInfo } from 'react';
import ReactDOM from 'react-dom/client';
import { container } from 'tsyringe';
import logger from '@/modules/logger/constants/logger';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import dayjs from 'dayjs';
import initCss from '@thisisdmg/tirecloud-patterns/v2/init.css?inline';

dayjs.extend(customParseFormat);

// Render the app
const domNode = document.getElementById('root');
if (domNode === null) throw new Error('ERR_REACT_ROOT_DOM_NODE_NOT_FOUND');

const configInstance = container.resolve(Config);

setupSentry();

const globalCatchAllLogger = (error: Error, errorInfo: ErrorInfo) =>
  logger.error('core', error, {
    extras: { componentStack: errorInfo.componentStack },
  });

const root = ReactDOM.createRoot(domNode, {
  onUncaughtError: Sentry.reactErrorHandler(globalCatchAllLogger),
  onCaughtError: Sentry.reactErrorHandler(globalCatchAllLogger),
  onRecoverableError: Sentry.reactErrorHandler(globalCatchAllLogger),
});

const initStyleSheet = document.createElement('style');
initStyleSheet.setAttribute('data-rc-order', 'prependQueue');
initStyleSheet.setAttribute('data-rc-priority', '-6666');
initStyleSheet.innerHTML = initCss;
document.head.prepend(initStyleSheet);

Promise.all([setupI18n(), configInstance.initialize()]).then(() => {
  // prettier-ignore
  root.render(<StrictMode><App /></StrictMode>);
  reportWebVitals();
});
